import classNames from 'classnames';
import { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import style from 'styles/components/common/ToastMessage';

export const ERROR_TYPE = 'error';
export const SUCCESS_TYPE = 'success';
export const NEUTRAL_TYPE = 'neutral';

const ToastMessage = ({ type = NEUTRAL_TYPE, className, content, visible }) => {
  const transitionRef = useRef();
  const isError = content instanceof Error;
  const appliedStyle = isError ? style[ERROR_TYPE] : style[type];
  const validContent = isError ? content.message : content;

  return (
    <div role="status">
      <CSSTransition
        nodeRef={transitionRef}
        key="toast"
        in={visible}
        timeout={500}
        classNames={{
          enter: 'fadeInOut-enter slideUp-enter',
          enterActive: 'fadeInOut-enter-active slideUp-enter-active',
          exit: 'fadeInOut-exit slideUp-exit',
          exitActive: 'fadeInOut-exit-active slideUp-exit-active',
        }}
        unmountOnExit
      >
        <p
          ref={transitionRef}
          className={classNames(className, {
            [classNames(style.messageContainer, appliedStyle)]: validContent,
          })}
          data-testid="toast-message"
        >
          {validContent}
        </p>
      </CSSTransition>
    </div>
  );
};

ToastMessage.propTypes = {
  content: AirbnbPropTypes.or([
    PropTypes.string.isRequired,
    AirbnbPropTypes.explicitNull(),
    PropTypes.instanceOf(Error),
  ]),
  visible: PropTypes.bool.isRequired,
  type: PropTypes.oneOf([ERROR_TYPE, SUCCESS_TYPE, NEUTRAL_TYPE]),
  className: PropTypes.string,
};

export default ToastMessage;
